<template lang="pug">
div
  .d-flex
    v-alert(
      text color="primary" v-if="!loading" flat
      max-width="1200"
      width="100%"
    ).sdo-radius.mb-8.overflow-hidden.pa-0.pb-0
      v-card-text

        record-status-wrap(
          :user-record="course.priority_user_prior_record.user_record"
          v-slot:default="{ color, label, group, status }"
        )
          .text-body-2.secondary--text
            .d-flex.align-center
              .pb-2
                strong.mr-2 Статус:
                span {{ label }}
              //- v-icon.ml-auto(
              //-   color="primary"  @click="openInfoModal"
              //- ) mdi-help-circle-outline
            //- .pb-2
            //-   strong.mr-2 Группа:
            //-   span {{ group.short_name || 'Не назначена' }}
            .pb-0
              strong.mr-2 Срок завершения:
              span {{ course.priority_user_prior_record.end_learning | dp('d MMMM y') }}

          template(
            v-if="status && status !== $conf.ATTESTATION_STATUSES.attestated "
          )
            template(v-if="status !== $conf.ATTESTATION_STATUSES.excluded")
              template(v-if="status !== $conf.ATTESTATION_STATUSES.refusedAttestation")
              .text-body-2.mt-4: strong.secondary--text Пройдено материала:
                v-progress-linear.mt-2(
                  :value="progress"
                  color="success lighten-1"
                  height="24" tile rounded
                )
                  .text-body-2 {{progress}}%
                .px-0.text-body-2.mt-4(
                  v-if="status !== $conf.ATTESTATION_STATUSES.allowedAttestation"
                )
                  strong.secondary--text.mb-2 Прохожу сейчас:
                  unit-card.mt-2(
                    v-if="currentUnit"
                    :unit="currentUnit"
                    :to=`{
                      name: 'EducationLessonList',
                      params: { courseId: course.id, unitId: currentUnit.id },
                    }`
                  )
            template(v-else)
              v-btn.mt-4(
                depressed outlined
                block :loading="loadingTrainingNotes" color="primary"
                @click="downloadTrainingNotes"
              ) Скачать справку об обучении
              trainingNote
          .text-body-1.mt-2.py-3.mb-0(
            color="info" text outlined
            v-else-if="status === $conf.ATTESTATION_STATUSES.attestated"
          )
            strong Поздравляем с успешным завершением курса.
            div.mt-2(v-if="!showDiplomaDownload")
              span Пожалуйста, дождитесь направления документа об успешном обучении
            v-btn.mt-4(
              v-else depressed
              block :loading="loadingCertificate" color="primary"
              @click="getUserData"
            ) Скачать удостоверение

  v-expansion-panels.mb-6(:mandatory="!isAttested" flat)
    v-expansion-panel
      v-expansion-panel-header
        .text-body-1.mb-3: strong Темы курса
          span.text-body-2.ml-2.grey--text {{ courseUnits.length }}
        template(#actions)
          span(v-if="!isAttested")
      v-expansion-panel-content
        lazy-load(
          v-model="loadMore"
          @on-response="({ items }) => courseUnits.push(...items)"
        )
          //- :isForbidden="!!idx && !courseUnits[idx - 1].user_passed"
          unit-card(
            v-for="(unit,idx) in courseUnits"
            :key="`${unit.id}${idx}`"
            :idx="idx"
            :unit="unit"
            :to=`{
              name: 'EducationLessonList',
              params: { courseId: course.id, unitId: unit.id },
            }`
          ).mb-4

    v-fade-transition
      v-skeleton-loader.fill-width(
        v-if="loading"
        type="list-item-two-line@5"
      )
  .text-body-1.mb-3: strong Итоговая работа
    span.text-body-2.ml-2.grey--text {{ course.tasks.length }}
  lesson-task(
    v-for="(task, idx) in course.tasks"
    :key="idx"
    :course="course"
    :disabled="![3,4].includes(course.priority_user_prior_record.user_record.status)"
    :task="task"
  )
</template>

<script>
import APIService from '@/services/APIService';
import { TASK_STATUSES } from '@/utils/constants';
import RecordStatusWrap from '@/components/Enrollment/RecordStatusWrap.vue';
import UnitCard from '@/modules/Education/Courses/components/UnitCard.vue';
import LessonTask from '../../../components/Lessons/LessonTask.vue';

export default {
  components: {
    RecordStatusWrap,
    LessonTask,
    UnitCard,
  },
  props: {
    course: { type: Object, required: true },
  },
  data: () => ({
    courseUnits: [],
    loading: true,
    loadingCertificate: false,
    loadingTrainingNotes: false,
    diploma: null,
    loadMore: null,
  }),
  computed: {
    showDiplomaDownload() {
      return [4, 5].includes(this.diploma?.status);
    },
    isAttested() {
      return [
        this.$conf.ATTESTATION_STATUSES.allowedAttestation,
        this.$conf.ATTESTATION_STATUSES.attestated,
      ].includes(this.course.prior_record_status);
    },
    currentUnit() {
      return this.courseUnits.find((unit) => !unit.user_passed);
    },
    progress() {
      const { courseUnits } = this;

      const filterQ = (item) => {
        const res = item.tasks.filter(
          ({ status }) => ![
            TASK_STATUSES.retake,
            TASK_STATUSES.notPassed,
            TASK_STATUSES.notChecked,
            TASK_STATUSES.inProcess,
            TASK_STATUSES.fail,
          ].includes(status),
        );
        return res;
      };
      const func = (acc, cur) => {
        const lessonLength = cur.tasks.length;

        return {
          length: acc.length + (lessonLength || 1),
          complete: acc.complete
            + (lessonLength ? filterQ(cur).length : Number(cur.user_passed)),
        };
      };

      const result = courseUnits.reduce(
        (acc, cur) => {
          const lessonsTasks = cur.lessons.reduce(func, { length: 0, complete: 0 });
          const tasksLength = cur.tasks.length;

          return {
            length: acc.length + lessonsTasks.length + (tasksLength || 1),
            complete: acc.complete + lessonsTasks.complete
              + (tasksLength ? filterQ(cur).length : Number(cur.user_passed)),
          };
        }, { length: 0, complete: 0 },
      );

      return Math.round((100 / result.length) * result.complete);
    },
  },
  async created() {
    this.loading = true;
    await this.getCourseUnits();
    if (this.$route.query.chat_id) {
      this.$router.replace({ query: {} });
      this.course.openChatAsStudent();
    }
    const { status } = this.course.priority_user_prior_record.user_record;
    if (status === this.$conf.ATTESTATION_STATUSES.attestated) await this.getDiploma();
    if (status === this.$conf.ATTESTATION_STATUSES.excluded) await this.getTrainingNote();
    this.loading = false;
  },
  methods: {
    async getTrainingNote() {
      const { data } = await this.$api.diploma.getTrainingNotes({
        'search[user_id]': this.$user.data.id,
        'search[prior_record_id]': this.course.priority_user_prior_record.id,
      });
      [this.trainingNote] = data.data;
    },
    async downloadTrainingNotes() {
      this.loadingTrainingNotes = true;
      const { data } = await this.$api.diploma.downloadTrainingNote(this.trainingNote.id);
      this.loadingTrainingNotes = false;
      const blob = new Blob([data], { type: 'application/pdf' });
      const objectUrl = URL.createObjectURL(blob);
      window.open(objectUrl);
    },
    async getDiploma() {
      // this.loading
      const { data } = await this.$api.diploma.getDiplomas({
        'search[user_id]': this.$user.data.id,
        'search[prior_record_id]': this.course.priority_user_prior_record.id,
      });
      this.diploma = data.data[0] || {};
    },
    async getUserData() {
      this.loadingCertificate = true;
      const { data } = await APIService.get('https://ipapi.co/json/', {
        // params: { fields: 'oscpu,query,regionName,lat,lon,isp,country,city' },
      }, {
        headers: { Accept: 'application/json' },
      });
      const userData = {
        ...data,
        os: await this.getOs(),
        browser: this.getBrowser(),
      };
      this.downloadCertificate(userData);
    },
    async getOs() {
      const ua = await navigator.userAgentData.getHighEntropyValues(['platformVersion']);
      let OSName = 'Unknown';
      if (window.navigator.userAgent.indexOf('Win') !== -1) OSName = 'Windows';
      if (navigator.userAgent.indexOf('Mac') !== -1) OSName = 'Mac/iOS';
      if (navigator.userAgent.indexOf('X11') !== -1) OSName = 'UNIX';
      if (navigator.userAgent.indexOf('Android') !== -1) OSName = 'Android OS';
      if (navigator.userAgent.indexOf('Linux') !== -1) OSName = 'Linux';
      if (OSName === 'Windows') {
        const majorPlatformVersion = Number(ua.platformVersion.split('.')[0]);
        if (majorPlatformVersion >= 13) {
          return 'Windows 11';
        }
        if (window.navigator.userAgent.indexOf('Windows NT 10.0') !== -1) OSName = 'Windows 10';
        if (window.navigator.userAgent.indexOf('Windows NT 6.3') !== -1) OSName = 'Windows 8.1';
        if (window.navigator.userAgent.indexOf('Windows NT 6.2') !== -1) OSName = 'Windows 8';
        if (window.navigator.userAgent.indexOf('Windows NT 6.1') !== -1) OSName = 'Windows 7';
        if (window.navigator.userAgent.indexOf('Windows NT 6.0') !== -1) OSName = 'Windows Vista';
        if (window.navigator.userAgent.indexOf('Windows NT 5.1') !== -1) OSName = 'Windows XP';
        if (window.navigator.userAgent.indexOf('Windows NT 5.0') !== -1) OSName = 'Windows 2000';
      }

      return OSName;
    },
    getBrowser() {
      const { userAgent } = navigator;
      const browserName = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(browserName[0])) {
        const rv = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
        return `IE ${rv[1] || ''}`;
      }
      const version = browserName[2] ? browserName[2] : null;
      const browser = browserName[1] ? browserName[1] : null;
      if (browser === null || version === null) {
        return 'Unknown Browser';
      }
      return `${browser} ${version}`;
    },
    async downloadCertificate(val) {
      const { data } = await this.$api.diploma.userDownloadDiploma(
        this.diploma.id,
        { download_request_snap: val },
      );
      this.loadingCertificate = false;
      const type = this.diploma.is_sign_required ? 'zip' : 'pdf';
      const blob = new Blob([data], { type: `application/${type}` });
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = `Удостоверение.${type}`;
      link.click();
      link.remove();
    },
    async getCourseUnits() {
      const params = {
        expand: 'lessons,tasks,user_passed',
        'per-page': -1,
      };
      const { items, loadMore } = await this.$api.courses.courseUnitIndex(
        this.course.id,
        params, { hideErrorToasts: true },
      );
      this.loadMore = loadMore;
      this.courseUnits = items;
      this.checkUnreads();
    },
    checkUnreads() {
      this.courseUnits.forEach((i) => {
        i.fetchUnread({ userId: this.$user.data.id });
      });
    },
  },
};
</script>
